module.exports = __webpack_public_path__ + "img/personal-header.2439fe04.png";